export default {
	name: "product-select-for-exTank-order",
	props: ["zoneId", "companyId"],
	emits: ["productSelected"],
	data() {
		return {
			products: [],
			customerHeadings: [
				{
					text: "Customer #",
					field: "companyId"
				},
				{
					text: "Customer Code",
					field: "customerCode"
				},
				{
					text: "Name",
					field: "registeredCompanyName"
				},
				{
					text: "ERP Customer Code",
					field: "erpCompanyCode"
				},
				{
					text: "VAT Number",
					field: "taxVatNumber"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			filter:{
				searchQuery: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			orderTotal: 0,
			orderTotalAsString: null,
			newAssignedCustomers: [],
			newUnassignedCustomers: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false,
			hasError: false
		};
	},
	methods: {
		getProducts(){
			let request = {
				companyId: this.companyId,
				searchQuery: this.filter.customerSearchQuery,
				zoneId: this.zoneId
			};
			exTankService.getExTankCompanyProductPricesForZone(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.products = successResponse.data.result;
						this.products = dataTableHelper.castFieldValues(this.products);
						for(let i = 0; i < this.products.length; i++){
							this.products[i].errorMessage = null;
							this.products[i].priceAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.products[i].basePrice);
							this.products[i].quantity = 1;
							this.products[i].discountedAmountTotal = 0;
							this.products[i].discountAmountAsString = null;
							this.products[i].priceAfterDiscount = null;
							this.products[i].priceAfterDiscountAsString = null;
							this.products[i].totalAfterDiscount = null;
							this.products[i].totalAfterDiscountAsString = null;
							if(this.products[i].discountAmount !== null && this.products[i].discountAmount > 0){
								this.products[i].discountedAmountTotal = this.products[i].quantity * this.products[i].discountAmount;
								this.products[i].discountAmountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.products[i].discountAmount);
								this.products[i].priceAfterDiscount = this.products[i].basePrice - this.products[i].discountAmount;
								this.products[i].priceAfterDiscountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.products[i].priceAfterDiscount);
								this.products[i].totalAfterDiscount = this.products[i].quantity * this.products[i].priceAfterDiscount;
								this.products[i].totalAfterDiscountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.products[i].totalAfterDiscount);
							}
							this.products[i].total = this.products[i].quantity * this.products[i].basePrice;
							this.products[i].totalAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.products[i].total);
							this.products[i].selected = false;
						}
					}
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			this.getProducts()
		},
		onQuantityInput(product){
			console.log("product.selected", product.selected);
			product.selected = true;
			product.errorMessage = null;
			//this.hasError = false;
			if(product.quantity === null || product.quantity === ""){
				product.errorMessage = "Quantity is required";
				//this.hasError = true;
			}
			else if(product.quantity <= 0){
				product.quantity = 1;
			}

			product.total = product.quantity * product.basePrice;
			product.totalAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(product.total);
			if(product.discountAmount !== null && product.discountAmount > 0){
				product.discountedAmountTotal = currencyHelper.roundToFourDecimalPlaces(product.quantity * product.discountAmount);
				product.totalAfterDiscount = currencyHelper.roundToFourDecimalPlaces(product.quantity * product.priceAfterDiscount);
				product.totalAfterDiscountAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(product.totalAfterDiscount);
			}
			this.calculateGrandTotalForOrder();
			this.onProductSelect();
		},
		calculateGrandTotalForOrder(){
			this.orderTotal = 0;
			for(let i = 0; i < this.products.length; i++){
				if(this.products[i].selected){
					if(this.products[i].discountAmount !== null && this.products[i].discountAmount > 0){
						this.orderTotal += this.products[i].totalAfterDiscount;
					}
					else {
						this.orderTotal += this.products[i].total;
					}
					this.orderTotal = currencyHelper.roundToFourDecimalPlaces(this.orderTotal);
				}
			}
			this.orderTotalAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderTotal);
		},
		onProductSelect(){
			this.orderTotal = 0;
			let productsToOrder = {
				selectedProducts: [],
				hasError: false
			};
			for(let i = 0; i < this.products.length; i++){
				if(this.products[i].selected){
					if(this.products[i].discountAmount !== null && this.products[i].discountAmount > 0){
						this.products[i].totalAfterDiscount = this.products[i].quantity * this.products[i].priceAfterDiscount;
						this.orderTotal += this.products[i].totalAfterDiscount;
					}
					else{
						this.orderTotal += this.products[i].total;
					}

					if(this.products[i].errorMessage !== null){
						productsToOrder.hasError = true;
					}

					this.orderTotal = currencyHelper.roundToFourDecimalPlaces(this.orderTotal);
					this.products[i].total = currencyHelper.roundToFourDecimalPlaces(this.products[i].quantity * this.products[i].basePrice);
					productsToOrder.selectedProducts.push(this.products[i]);
				}
				else{
					this.products[i].errorMessage = null;
					this.products[i].quantity = 1;
					this.products[i].total = this.products[i].quantity * this.products[i].basePrice;
					this.products[i].totalAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.products[i].total);
				}
			}
			//productsToOrder.hasError = this.hasError;
			this.orderTotalAsString = currencyHelper.numberToCurrencyWithFourDecimalPlaces(this.orderTotal);
			// this.$emit("productSelected", selectedProducts);
			this.$emit("productSelected", productsToOrder);
		}
	},
	mounted: function () {
		
	},
	watch:{
		zoneId:{
			handler: function(){
				if(this.zoneId !== null && this.zoneId !== undefined){
					this.getProducts();
				}
			},
			immediate: true,
			deep: true
		}
	}
};